export default function lowerCase(string) {
  if (typeof string !== "string") return;
  return string.toLowerCase();
}
